
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from '@/app/App';
import { AppProvider } from '@/app/state/AppContext';
import { AuthProvider } from '@/app/state/AuthContext';
import { SubscriptionProvider } from '@/app/state/SubscriptionContext';
import { UsageProvider } from '@/app/state/UsageContext';
import { ThemeProvider } from '@/app/state/ThemeContext';
import { OnboardingProvider } from '@/app/state/OnboardingContext';
import { PricingProvider } from '@/app/state/PricingContext';
import { DebugModeProvider } from '@/app/state/DebugModeContext';
import { AppErrorBoundary } from '@/shared/components/common/ErrorBoundary';
import { initializeErrorMonitoring } from '@/services/errorMonitoringService';
import '@/app/styles/global.css';

// Initialize error monitoring before app renders
initializeErrorMonitoring();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <HelmetProvider>
        <ThemeProvider>
          <DebugModeProvider>
            <BrowserRouter>
              <AuthProvider>
                <SubscriptionProvider>
                  <UsageProvider>
                    <OnboardingProvider>
                      <AppProvider>
                        <PricingProvider>
                          <App />
                        </PricingProvider>
                      </AppProvider>
                    </OnboardingProvider>
                  </UsageProvider>
                </SubscriptionProvider>
              </AuthProvider>
            </BrowserRouter>
          </DebugModeProvider>
        </ThemeProvider>
      </HelmetProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);